import { Routes } from '@angular/router';
import { providePathwayStore } from '@app/store/pathway';
import { provideCoursesStore } from '@app/store/courses';
import { ModalComponent } from '@shared/components';
import { ViewComponent } from './view/view.component';
import { AddComponent } from './add/add.component';
import { EditComponent } from './edit/edit.component';
import { SelectCourseDialogComponent } from './select-course-dialog/select-course-dialog.component';

export const predefinedPathwaysModalRoutes: Routes = [
    {
        path: 'predefined-pathways/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...providePathwayStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'predefined-pathways/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...providePathwayStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'predefined-pathways/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...providePathwayStore()],
        children: [{ path: '', component: EditComponent }],
    },
    {
        path: 'select-predefined-pathway-course',
        component: ModalComponent,
        outlet: 'dialog',

        providers: [...provideCoursesStore()],
        children: [{ path: '', component: SelectCourseDialogComponent }],
    },
];
